import React from 'react';
import { enumValue } from '~/util';
import { usePatientService } from '~/services';
import { Notes } from '../Notes';

interface QualityGapNotesProps {
    entityId: number;
    patientId: number;
}
export function QualityGapNotes({ entityId, patientId }: QualityGapNotesProps) {
    const { updateQualityGap } = usePatientService();

    async function addNote(note: NewNoteType) {
        await updateQualityGap(entityId, patientId, note);
    }

    return (
        <Notes
            addNote={addNote}
            entityId={entityId}
            noteEntity="quality_gap.id"
            noteType={enumValue(['note', 'type', 'Quality Gap Note']) as number}
        />
    );
}
